import config from 'config';
import tmpl from './index.phtml';
import View from 'lib/View';

export default View.extend({
	template: tmpl,

	events: {
		'click #visit_draft_send_modal_confirm': 'sendAll'
	},

	sendAll: function( evt )
	{
		this.$("#visit-draft-send-modal").modal('hide');

		var pending = this.collection.getList( 'draft' );
		var chain = Promise.resolve();

		_.each( pending, function( visit )
		{
			visit.set({ todo: 'update' });
			chain = chain.then( function()
			{
				return app.persistModel( visit );
			} );
		});

		chain.then( function()
		{
			app.commit();
		} );
	},

	initialize: function()
	{
		this.listenTo( this.collection, 'all', this.render );
	},

	render: function()
	{
		this.doRender({
			visit_list: this.collection.getList( this.type ),
			title: this.title,
			type: this.type
		});
	}
});
